import ResourceManager from "@/pages/admin/ResourceManager";

export default function AdminServices() {
  return (
    <ResourceManager
      title="Services & Tarifs"
      endpoint="services"
      defaultItem={{ active: true, price_type: "hourly", vat: 0, duration: 1, unit: "heure", order: 0, price: 0, deposit_percent: 100 }}
      columns={[
        { key: "name", label: "Nom" },
        { key: "category", label: "Catégorie" },
        { key: "price", label: "Prix", render: (it) => `${Number(it.price || 0).toFixed(2)} € ${it.price_type === "hourly" ? "/h" : it.price_type === "session" ? "/session" : it.price_type === "day" ? "/jour" : ""}` },
        { key: "deposit_percent", label: "Payé à la résa", render: (it) => `${it.deposit_percent ?? 100}%` },
        { key: "active", label: "Actif" },
      ]}
      fields={[
        { name: "name", label: "Nom du service" },
        { name: "category", label: "Catégorie", placeholder: "ex: Studio" },
        { name: "price", label: "Prix (€)", type: "number" },
        { name: "price_type", label: "Type de prix", type: "select", options: ["hourly", "fixed", "session", "day"] },
        { name: "deposit_percent", label: "Payé à la réservation (%) — 100 = intégral, 50 = acompte moitié", type: "number" },
        { name: "vat", label: "TVA (%)", type: "number" },
        { name: "duration", label: "Durée (heures, indicatif)", type: "number" },
        { name: "min_duration", label: "Durée minimum (heures)", type: "number" },
        { name: "unit", label: "Unité", placeholder: "heure / session / jour" },
        { name: "order", label: "Ordre d'affichage", type: "number" },
        { name: "active", label: "Actif", type: "switch" },
        { name: "image", label: "Image (URL)", type: "image", full: true },
        { name: "description", label: "Description", type: "textarea" },
        { name: "conditions", label: "Conditions", type: "textarea" },
      ]}
    />
  );
}
